import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Helmet } from "react-helmet";
import PageSEO from "../Components/PageSEO";
import Reviews from "../Components/Reviews";
import ScrollReveal from "../Components/ScrollReveal";

const ReviewList = () => {
  return (
    <>
      <PageSEO
        title="Reviews | American Legacy Tours"
        description="Read 3,500+ five-star reviews for American Legacy Tours on TripAdvisor. Cincinnati's most reviewed tour company &amp; 2022–2024 Travelers' Choice Award winner."
        path="/reviews"
      />

      <div className="reviews-page-hero">
        <Container>
          <h1>What Our Guests Say</h1>
          <p>Real reviews from real adventurers.</p>
        </Container>
      </div>

      <div className="reviews-page-body">
        <Container>
          <ScrollReveal>
            <Row style={{ marginLeft: 0, marginRight: 0 }}>
              <Reviews numToDisplay={16} />
            </Row>
          </ScrollReveal>
          <Row>
            <Col style={{ textAlign: "center", marginTop: 40 }}>
              <a
                href="https://www.google.com/search?q=American+Legacy+Tours#lrd=0x8841b3fd868b6ea1:0xfae885fabe92c950,1,,,"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-outline-light-custom"
              >
                See All Google Reviews
              </a>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default ReviewList;
